import { BluetoothCoreService } from '@src/services/bluetooth/BluetoothCoreService'
import { getStoreId } from '@utils/EnvironmentUtil'
import { LatencyMetric } from '@amzn/ihm-associate-tools-js-lib'

/**
 * Listener for printing service
 */
export class PrintingService {

    /**
     * Sends print job to the connected bluetooth printer.
     * @return {Promise} - success when the printer has received the job.
     */
    public static print (config) {
        const sendPrintJobLatencyMetrics = new LatencyMetric(getStoreId, 'Time', 'IhmFlyingDutchman', 'printingService.sendPrintJob')
        sendPrintJobLatencyMetrics.start()
        return BluetoothCoreService.bluetoothPrint(config)
            .finally(() => {
                sendPrintJobLatencyMetrics.stop()
            })
    }
}
